import { configureStore } from '@reduxjs/toolkit';
import surveyFormatReducer from '~app/components/Survey/SurveyFormat/surveyFormatSlice';

export const store = configureStore({
  reducer: {
    surveyFormat: surveyFormatReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
